import { ReportFileViewerPage } from '@/features/reports/report-file-viewer-page';

const UserAuditViewerPage = () => <ReportFileViewerPage backLabel="Back to User Audit" backTo="/operations/user-audit" />;
UserAuditViewerPage.displayName = 'UserAuditViewerPage';

export default UserAuditViewerPage;
